import { ROUTES_NAMES } from 'constants/microsoftgraph.routes'
import { Mock } from 'types/global'

export const MocksMicrosoftGraph: Mock[] = [
    {
        'url': ROUTES_NAMES.user.get.me,
        'method': 'GET',
        'data': {
            '@odata.context': 'https://graph.microsoft.com/v1.0/$metadata#users/$entity',
            'businessPhones': '[]',
            'displayName': 'Diego Costa da Silva - Mock',
            'givenName': 'Diego',
            'jobTitle': 'Lider Tecnico',
            'mail': 'nadaparaver@email.com.br - mock',
            'mobilePhone': 'null',
            'officeLocation': 'RJ - Passeio 42',
            'preferredLanguage': 'null',
            'surname': 'Costa da Silva - Mock',
            'userPrincipalName': 'nadaparaver@email.com.br',
            'id': 'cf193960-5d30-4213-a803-e09fe811d780'
        }
    },
    {
        'url': ROUTES_NAMES.user.get.by_saaccount_name('meu.teste'),
        'method': 'GET',
        'data': {
            'value': [
                {
                    'businessPhones': '[]',
                    'displayName': 'Indicadores',
                    'givenName': 'Indicadores',
                    'jobTitle': '-',
                    'mail': 'qualquercoisa@arrobaemail.com.br',
                    'mobilePhone': 'null',
                    'officeLocation': 'Passeio 42',
                    'preferredLanguage': 'null',
                    'surname': 'Indicadores',
                    'userPrincipalName': 'qualquercoisa@arrobaemail.com.br',
                    'id': '4b12668a-5f7a-473c-b0f7-284f33ae0b91'
                }
            ]
        }
    },
    {
        'url': ROUTES_NAMES.user.get.by_saaccount_name('diego.costas'),
        'method': 'GET',
        'data': {
            'value': [
                {
                    '@odata.context': 'https://graph.microsoft.com/v1.0/$metadata#users/$entity',
                    'businessPhones': '[]',
                    'displayName': 'Mock2',
                    'givenName': 'Diego',
                    'jobTitle': 'Lider Tecnico',
                    'mail': 'nadaparaver@email.com.br',
                    'mobilePhone': 'null',
                    'officeLocation': 'RJ - Passeio 42',
                    'preferredLanguage': 'null',
                    'surname': 'Costa da Silva - Mock',
                    'userPrincipalName': 'nadaparaver@email.com.br',
                    'id': 'cf193960-5d30-4213-a803-e09fe811d780'
                }
            ]
        }
    },
    {
        'url': ROUTES_NAMES.user.get.by_saaccount_name('jean.jesus'),
        'method': 'GET',
        'data': {
            'value': [
                {
                    'businessPhones': '[]',
                    'displayName': 'Jean Diego Motta de Jesus',
                    'givenName': 'Jean',
                    'jobTitle': 'ANALISTA SR',
                    'mail': 'nadaparaver@email.com.br',
                    'mobilePhone': 'null',
                    'officeLocation': 'RJ - Passeio 42',
                    'preferredLanguage': 'null',
                    'surname': 'Diego Motta de Jesus',
                    'userPrincipalName': 'nadaparaver@email.com.br',
                    'id': 'd420e5b1-52a1-4608-82ea-66dc553cf033'
                }
            ]
        }
    },
    {
        'url': ROUTES_NAMES.user.get.by_saaccount_name('guilherme.ocarvalho'),
        'method': 'GET',
        'data': {
            'value': [
                {
                    'businessPhones': '[]',
                    'displayName': 'Guilherme Oliveira de Carvalho',
                    'givenName': 'Guilherme',
                    'jobTitle': 'Especialista TI',
                    'mail': 'nadaparaver@email.com.br',
                    'mobilePhone': 'null',
                    'officeLocation': 'RJ - Passeio 42',
                    'preferredLanguage': 'null',
                    'surname': 'Oliveira de Carvalho',
                    'userPrincipalName': 'nadaparaver@email.com.br',
                    'id': '8d13623b-d777-4036-bcf9-e4159076df68'
                }
            ]
        }
    }
]